/** Default flag for the developer Custom Code demo page. Override with `?flag=`. */
export const DSP_SAMPLE_EXPERIMENT_FLAG_KEY = 'dashboard-fm-widget';

export const AMPLITUDE_EXPERIMENT_READY_TIMEOUT_MS = 2000;
export const AMPLITUDE_EXPERIMENT_POLL_INTERVAL_MS = 50;

export const DEFAULT_EXPERIMENT_FALLBACK = 'off';

export const EXPERIMENT_ON_VALUES = ['on', 'treatment'] as const;
